import Exams from "@/packages/exams/view/exam";
import ExamCurrentResults from "@/packages/exams/components/examCurrentResults";
import ExamCard from "@/packages/exams/components/examCard";
import DashboardLayout from "@/packages/dashboard/modules/dashboard/views/dashboardLayout";
import Auth from "@/packages/dashboard/modules/auth/middleware/Auth";
import ProfileComplete from "@/packages/dashboard/modules/auth/middleware/ProfileComplete";
import examBookings from "./components/units";
// import ExamHistoricalResults from "@/packages/exams/components/examHistoricalResults";
// import ExamTranscript from "@/packages/exams/components/examTranscript";
import examTimetable from "@/packages/exams/components/examTimetable";
import ExamTranscriptCard from "@/packages/exams/components/examTranscriptCard";
import HistoricalResultsCard from "@/packages/exams/components/HistoricalResultsCard";
import examBookingPayments from "@/packages/exams/components/examBookingPayments";
import examBookingList from "@/packages/exams/components/examBookingList";
import BookedUnitReceipt from "@/packages/exams/components/BookedUnitReceipt";
import ibl from "./components/IBL.vue";
import UnitNotesPdf from "@/packages/exams/components/UnitNotesPdf";
import UnitNotes from "@/packages/exams/components/UnitNotes";

const examRoutes = [
  {
    path: "/exams",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Exams",
        component: Exams,
        children: [
          {
            path: "current-results",
            name: "ExamCurrentResults",
            component: ExamCurrentResults,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "historical-results",
            name: "ExamHistoricalResults",
            component: HistoricalResultsCard,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "transcripts",
            name: "ExamTranscriptCard",
            component: ExamTranscriptCard,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          // {
          //   path: "download-transcript",
          //   name: "ExamTranscriptCard",
          //   component: ExamTranscriptCard,
          //   meta: { middleware: [Auth, ProfileComplete] },
          // },
          {
            path: "timetable",
            name: "ExamTimetable",
            component: examTimetable,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "bookings",
            name: "ExamBookings",
            component: examBookings,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "payments/:code",
            name: "ExamBookingPayments",
            component: examBookingPayments,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "student-bookings/:code",
            name: "ExamBookingList",
            component: examBookingList,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "card/:code?",
            name: "ExamCard",
            component: ExamCard,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "receipt/:code?",
            name: "BookedUnitReceipt",
            component: BookedUnitReceipt,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "ibl",
            name: "IBL",
            component: ibl,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "units",
            name: "UnitNotes",
            component: UnitNotes,
            meta: { middleware: [Auth, ProfileComplete] },
          },
          {
            path: "notes/:unitCode?",
            name: "Notes",
            component: UnitNotesPdf,
            meta: { middleware: [Auth, ProfileComplete] },
          },
        ],
      },
    ],
  },
];

export default examRoutes;
